export const EMPTY_ARRAY: Array<any> = [];
export const EMPTY_OBJECT = Object.freeze({});
